import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import ErrorBoundary from "./ErrorBoundary";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { REACT_APP_SITE_NAME } from "../config";
import { redirect } from "../redux/actions/common.actions";
import Login from "./Login";
import Interest from "./Interest";
import Help from "./Help";
import RegisterAdmin from "./RegisterAdmin";
import Assets from "./Assets/Index";
import AssetDetail from "./Assets/AssetDetail";
import AssetAdd from "./Assets/AssetAdd";
import AssetEdit from "./Assets/Edit";
import AssetImport from "./Assets/AssetImport";
import Sites from "./Sites/Index";
import SiteDetail from "./Sites/SiteDetail";
import SiteAdd from "./Sites/SiteAdd";
import SiteEdit from "./Sites/Edit";
import Events from "./Events/Index";
import EventAdd from "./Events/Add";
import EventDetail from "./Events/Detail";
import Campaigns from "./Campaigns/Index";
import CampaignAdd from "./Campaigns/Add";
import CampaignEdit from "./Campaigns/Edit";
import CampaignDetail from "./Campaigns/Detail";
import CampaignItemDetail from "./Campaigns/ItemDetail";
import CampaignItemsEdit from "./Campaigns/ItemsEdit";

function App() {
  const common = useSelector(state => state.common);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (common.redirectTo) {
      history.push(common.redirectTo);
      dispatch(redirect());
    }
  }, [common]);

  return (
    <div id="site-wrap">
      <Helmet>
        <title>{REACT_APP_SITE_NAME}</title>
      </Helmet>
      <ErrorBoundary>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route path="/login" component={Login} />
          <Route path="/interest" component={Interest} />
          <Route path="/register_admin" component={RegisterAdmin} />
          <Route path="/help" component={Help} />
          <Route exact path="/assets/add" component={AssetAdd} />
          <Route exact path="/assets/import" component={AssetImport} />
          <Route path="/assets/:key/edit" component={AssetEdit} />
          <Route path="/assets/:key" component={AssetDetail} />
          <Route exact path="/assets" component={Assets} />
          <Route exact path="/sites/add" component={SiteAdd} />
          <Route path="/sites/:key/edit" component={SiteEdit} />
          <Route path="/sites/:key" component={SiteDetail} />
          <Route exact path="/sites" component={Sites} />
          <Route exact path="/events/add" component={EventAdd} />
          <Route path="/events/:key" component={EventDetail} />
          <Route path="/events" component={Events} />
          <Route
            path="/campaigns/:key/items/edit"
            component={CampaignItemsEdit}
          />
          <Route path="/campaigns/items/:key" component={CampaignItemDetail} />
          <Route exact path="/campaigns/add" component={CampaignAdd} />
          <Route path="/campaigns/:key/edit" component={CampaignEdit} />
          <Route path="/campaigns/:key" component={CampaignDetail} />
          <Route path="/campaigns" component={Campaigns} />
          <Redirect from="*" to="/" />
        </Switch>
      </ErrorBoundary>
    </div>
  );
}

export default App;
